import { render, staticRenderFns } from "./EmployeeForm.vue?vue&type=template&id=bb190b60"
import script from "./EmployeeForm.vue?vue&type=script&lang=js"
export * from "./EmployeeForm.vue?vue&type=script&lang=js"
import style0 from "./EmployeeForm.vue?vue&type=style&index=0&id=bb190b60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports